








require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi,  { BasePath } from '../ts/api';
import { DefaultApi, Image, Credentials } from '../api';
import { SetToken } from '../ts/api';
import router from '../router';



let api: DefaultApi;

@Component(
  {
    components:{
    }
  }
)
export default class Login extends Vue {
  credentials = {} as Credentials;
  imgs = [] as Image[];
  
  mounted(){
    api = NewApi()
    
  }
  
login(){
  let ctx = this
  api.loginPost(this.credentials).then(function(r){
      SetToken(r.data)
      ctx.bitschen()     
  }).catch(e => console.error("could not login"))
}

bitschen(){
  this.$router.push('/dashboard')
}
}
